/**
 * Checks whether an object is both an array and is empty.
 * @param arr {any}
 * @return {boolean} true if not an array or empty. Otherwise, false.
 */
export const isNullOrEmptyArray = (arr) =>
  !arr || !Array.isArray(arr) || arr.length === 0

/**
 * Checks whether all elements within the given array are of a certain type e.g. typeof === 'string'
 * @param arr
 * @param type {string}
 * @return {boolean} true if all elements are of type. False if not array or not all elements are of same type
 */
export const isArrayOfType = (arr, type) => {
  return (
    arr &&
    Array.isArray(arr) &&
    arr.length &&
    // eslint-disable-next-line valid-typeof
    arr.every((i) => typeof i === type)
  )
}
